module.exports = __webpack_public_path__ + "img/005.e46b3a3d.png";